import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/HomeView.vue'
import store from '@/store'

// Usuarios
import Login           from '@/views/usuarios/Login.vue'
import Perfil          from '@/views/usuarios/Perfil.vue'
import PerfilTeacher   from '@/views/usuarios/PerfilTeacher.vue'
import PerfilEditor   from '@/views/usuarios/PerfilEditor.vue'
PerfilEditor

// Componentes
import Carga           from '@/views/usuarios/Carga.vue'

// Alumnos
import Niveles          from '@/views/alumnos/Niveles.vue'
import DetalleGrupo     from '@/views/alumnos/DetalleGrupo.vue'
import GruposAlumnos    from '@/views/alumnos/GruposAlumnos.vue'
import TwilioVentas     from '@/views/alumnos/TwilioVentas.vue'
import Calificaciones   from '@/views/alumnos/Calificaciones.vue'
import Kardex           from '@/views/alumnos/Kardex.vue'
import Certificados     from '@/views/alumnos/Certificados.vue'
import RegistrarDatos   from '@/views/alumnos/RegistrarDatos.vue'
import MiQr             from '@/views/alumnos/MiQr.vue'

// Recursos
import RecursosGrupoUsuario      from '@/views/recursos/RecursosGrupoUsuario.vue'
import RecursosGrupoCerti        from '@/views/recursos/RecursosGrupoCerti.vue'
import Books                     from '@/views/recursos/Books.vue'
import Ejercicio                 from '@/views/recursos/Ejercicio.vue'
import Examen                    from '@/views/recursos/Examen.vue'
import ExamenCalidad             from '@/views/recursos/ExamenCalidad.vue'
import Videos                    from '@/views/recursos/Videos.vue'

// Soporte
import Tickets                   from '@/views/soporte/Tickets.vue'
import RecuperarPassword         from '@/views/soporte/RecuperarPassword.vue'
import ReenviarCorreo            from '@/views/soporte/ReenviarCorreo.vue'
import Comentarios               from '@/views/soporte/Comentarios.vue'     //Angel Rodriguez

// Diccionario
import Diccionario               from '@/views/diccionario/Diccionario.vue'
import Calendarios               from '@/views/alumnos/Calendarios.vue'
import Reglamento                from '@/components/perfil/ReglamentoT.vue'

// Grupos
import GruposTeacher             from '@/views/grupos/GruposTeacher.vue'
import DetalleGrupoTeacher       from '@/views/grupos/DetalleGrupoTeacher.vue'
import ListaAlumnos              from '@/views/grupos/ListaAlumnos.vue'
import ListaAsistencia           from '@/views/grupos/ListaAsistencia.vue'
import RecursoGrupo              from '@/views/grupos/RecursoGrupo.vue'
import CalificacionGrupo         from '@/views/grupos/CalificacionGrupo.vue'

// notificaciones
import PruebaNotificacion        from '@/components/notificaciones/PruebaNotificacion.vue'
import Incidencias               from '@/components/Incidencias.vue'
import MisIncidencias            from '@/components/MisIncidencias.vue'

import NiVendedora               from '@/views/editor/NiVendedora.vue'
import TicketsEditor             from '@/views/editor/TicketsEditor.vue'
import KPIGeneral                from '@/views/editor/KPIGeneral.vue'
import KPIMontos                 from '@/views/editor/KPIMontos.vue'
import RepSemanalVentas          from '@/views/editor/RepSemanalVentas.vue'
import Requisiciones             from '@/views/editor/Requisiciones.vue'
import ActividadesDiariasTodos   from '@/views/editor/ActividadesDiariasTodos.vue'

import CursoInduccion            from '@/views/induccion/CursoInduccion.vue'
import MisPedidos                from '@/views/alumnos/MisPedidos.vue'

import VideosYt               from '@/views/youtube/VideosYt.vue'

import Recomendados           from '@/views/alumnos/Recomendados.vue'
import MisFacturas            from '@/views/alumnos/MisFacturas.vue'
import MisConstancias from '@/components/perfil/MisConstancias.vue'
import Test from '@/test.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: '',
  base: process.env.BASE_URL,
  routes: [

    { path: '/test',
      name: 'test',
      component: Test,
      meta: {
        libre: true
      }
    },

    { path: '/pruebanoti'          , name: 'PruebaNotificacion'     , component: PruebaNotificacion,
      meta: { libre: true }},

    { path: '/'          , name: 'Carga'     , component: Carga,
      meta: { libre: true }},

    { path: '/login'     , name: 'Login'     , component: Login,
      meta: { libre: true }},

    { path: '/cursoinduccion'    , name: 'CursoInduccion'      , component: CursoInduccion,
      meta: { ADMIN: true, TEACHER: true, ALUMNO: true }},

    { path: '/videosyt'    , name: 'VideosYt'      , component: VideosYt,
      meta: { ADMIN: true, TEACHER: true, ALUMNO: true }},

    /*********************************************************************/

    { path: '/niveles'         , name: 'Niveles'         , component: Niveles,
      meta: { ALUMNO: true }},

    { path: '/detallegrupo'    , name: 'DetalleGrupo'    , component: DetalleGrupo,
      meta: { ALUMNO: true }},

    { path: '/gruposalumnos'   , name: 'GruposAlumnos'   , component: GruposAlumnos,
      meta: { ALUMNO: true }},

    { path: '/twilioventas'   , name: 'TwilioVentas'   , component: TwilioVentas,
      meta: { ALUMNO: true }},

    { path: '/calificaciones'  , name: 'Calificaciones'  , component: Calificaciones,
      meta: { ALUMNO: true }},

    { path: '/kardex'          , name: 'Kardex'          , component: Kardex,
      meta: { ALUMNO: true }},

    { path: '/certificados'    , name: 'Certificados'    , component: Certificados,
      meta: { ALUMNO: true }},

    { path: '/registrardatos'  , name: 'RegistrarDatos'  , component: RegistrarDatos,
      meta: { ALUMNO: true }},

    /*********************************************************************/

    { path: '/recursosgrupousuario'  , name: 'RecursosGrupoUsuario'  , component: RecursosGrupoUsuario,
      meta: { ALUMNO: true }},

    { path: '/recursosgrupocerti'    , name: 'RecursosGrupoCerti'    , component: RecursosGrupoCerti,
      meta: { ALUMNO: true }},

    { path: '/books'                 , name: 'Books'                 , component: Books,
      meta: { ALUMNO: true }},

    { path: '/ejercicio'             , name: 'Ejercicio'             , component: Ejercicio,
      meta: { ALUMNO: true }},

    { path: '/mi-qr',
      name: 'miqr',
      component: MiQr,
      meta: { ALUMNO: true }
    },

    { path: '/examen'                , name: 'Examen'                , component: Examen,
      meta: { ALUMNO: true }},

    { path: '/examencalidad'         , name: 'ExamenCalidad'         , component: ExamenCalidad,
      meta: { ALUMNO: true }},

    { path: '/videos'                , name: 'Videos'                , component: Videos,
      meta: { ALUMNO: true }},

    /*********************************************************************/

    { path: '/perfil'           , name: 'Perfil'             , component: Perfil,
      meta: { ADMIN: true, ALUMNO: true}},

    { path: '/home'             , name: 'Home'               , component: Home,
      meta: { ADMIN: true, ALUMNO: true }},

    { path: '/perfilteacher'    , name: 'PerfilTeacher'      , component: PerfilTeacher,
      meta: { ADMIN: true, TEACHER: true, EDITOR: true }},

    { path: '/perfileditor'     , name: 'PerfilEditor'       , component: PerfilEditor,
      meta: { ADMIN: true, TEACHER: true, EDITOR: true }},

    { path: '/mispedidos'       , name: 'MisPedidos'         , component: MisPedidos,
      meta: { ADMIN: true, TEACHER: true, ALUMNO: true }},


    /*********************************************************************/

    { path: '/tickets'           , name: 'Tickets'            , component: Tickets,
      meta: { ADMIN: true, ALUMNO: true, TEACHER: true}},

    { path: '/recuperarpassword' , name: 'RecuperarPassword'  , component: RecuperarPassword,
      meta: { libre: true }},

    { path: '/reenviarcorreo'    , name: 'ReenviarCorreo'     , component: ReenviarCorreo,
      meta: { libre: true }},

    { path: '/comentarios'       , name: 'Comentarios'        , component: Comentarios,
      meta: { ADMIN: true, ALUMNO: true, TEACHER: true}},

    /*********************************************************************/

    { path: '/diccionario'    , name: 'Diccionario'      , component: Diccionario,
      meta: { ADMIN: true, ALUMNO: true, TEACHER: true}},

    { path: '/calendarios'    , name: 'Calendarios'      , component: Calendarios,
      meta: { ADMIN: true, ALUMNO: true}},

    { path: '/reglamento'     , name: 'Reglamento'       , component: Reglamento,
      meta: { ADMIN: true, ALUMNO: true, TEACHER: true}},

    /*********************************************************************/

    { path: '/gruposteacher'        , name: 'GruposTeacher'          , component: GruposTeacher,
      meta: { ADMIN: true, TEACHER: true}},

    { path: '/detallegrupoteacher'  , name: 'DetalleGrupoTeacher'    , component: DetalleGrupoTeacher,
      meta: { ADMIN: true, TEACHER: true}},

    { path: '/listaalumnos'         , name: 'ListaAlumnos'           , component: ListaAlumnos,
      meta: { ADMIN: true, TEACHER: true}},

    { path: '/listaasistencia'      , name: 'ListaAsistencia'        , component: ListaAsistencia,
      meta: { ADMIN: true, TEACHER: true}},

    { path: '/recursogrupo'         , name: 'RecursoGrupo'           , component: RecursoGrupo,
      meta: { ADMIN: true, TEACHER: true}},

    { path: '/calificaciongrupo'    , name: 'CalificacionGrupo'      , component: CalificacionGrupo,
      meta: { ADMIN: true, TEACHER: true}},

    /*********************************************************************/
    { path: '/incidencias'    , name: 'Incidencias'      , component: Incidencias,
      meta: { ADMIN: true, TEACHER: true}},

    { path: '/misincidencias'    , name: 'MisIncidencias'      , component: MisIncidencias,
    meta: { ADMIN: true, ALUMNO: true}},

    { path: '/misfacturas'    , name: 'MisFacturas'      , component: MisFacturas,
      meta: { ADMIN: true, ALUMNO: true, TEACHER: true}},

    { path: '/misconstancias'    , name: 'MisConstancias'      , component: MisConstancias,
      meta: { ADMIN: true, ALUMNO: true, TEACHER: true}},

    //

    { path: '/nivendedora'      , name: 'NiVendedora'        , component: NiVendedora,
      meta: { ADMIN: true, TEACHER: true, EDITOR: true }},

    { path: '/ticketseditor'    , name: 'TicketsEditor'      , component: TicketsEditor,
      meta: { ADMIN: true, TEACHER: true, EDITOR: true }},

    { path: '/kpigeneral'       , name: 'KPIGeneral'         , component: KPIGeneral,
      meta: { ADMIN: true, TEACHER: true, EDITOR: true }},

    { path: '/kpimontos'        , name: 'KPIMontos'          , component: KPIMontos,
      meta: { ADMIN: true, TEACHER: true, EDITOR: true }},

    { path: '/repsemanalventas' , name: 'RepSemanalVentas'   , component: RepSemanalVentas,
      meta: { ADMIN: true, TEACHER: true, EDITOR: true }},

    { path: '/requisiciones'    , name: 'Requisiciones'      , component: Requisiciones,
      meta: { ADMIN: true, TEACHER: true, EDITOR: true }},

    /*********************************************************************/
    { path: '/recomendados'    , name: 'Recomendados'      , component: Recomendados,
      meta: { ADMIN: true, TEACHER: true, EDITOR: true, ALUMNO: true }},
    { path: '/actividadesdiariastodos'    , name: 'ActividadesDiariasTodos'      , component: ActividadesDiariasTodos,
      meta: { ADMIN: true, TEACHER: true, EDITOR: true }},

  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.libre)) {
    next()
  } else if (store.state.login.usuario.roll == 'ADMINISTRADOR') {
    if (to.matched.some(record => record.meta.ADMIN)) {
      next()
    }
  } else if (store.state.login.usuario.roll == 'ALUMNO') {
    if (to.matched.some(record => record.meta.ALUMNO)) {
      next()
    }
  } else if (store.state.login.usuario.roll == 'TEACHER') {
    if (to.matched.some(record => record.meta.TEACHER)) {
      next()
    }
  } else if (store.state.login.usuario.roll == 'EDITOR') {
    if (to.matched.some(record => record.meta.EDITOR)) {
      next()
    }
  } else {
    next({
      name: 'Login'
    })
  }
})

export default router
